export const PROYECTO_DETALLE_LOADING = 'PROYECTO_DETALLE_LOADING';
export const PROYECTO_DETALLE_LOADED = 'PROYECTO_DETALLE_LOADED';
export const PROYECTO_DETALLE_ERROR = 'PROYECTO_DETALLE_ERROR';

export const PROYECTO_LOADING = 'PROYECTO_LOADING';
export const PROYECTO_LOADED = 'PROYECTO_LOADED';
export const PROYECTO_ERROR = 'PROYECTO_ERROR';

export const PROYECTO_SOLICITUD_LOADING = 'PROYECTO_SOLICITUD_LOADING';
export const PROYECTO_SOLICITUD_LOADED = 'PROYECTO_SOLICITUD_LOADED';
export const PROYECTO_SOLICITUD_ERROR = 'PROYECTO_SOLICITUD_ERROR';

export const MIS_PROYECTOS_LOADING = 'MIS_PROYECTOS_LOADING';
export const MIS_PROYECTOS_LOADED = 'MIS_PROYECTOS_LOADED';
export const MIS_PROYECTOS_ERROR = 'MIS_PROYECTOS_ERROR';

export const PROYECTO_SOLICITUDES_LOADING = 'PROYECTO_SOLICITUDES_LOADING';
export const PROYECTO_SOLICITUDES_LOADED = 'PROYECTO_SOLICITUDES_LOADED';
export const PROYECTO_SOLICITUDES_ERROR = 'PROYECTO_SOLICITUDES_ERROR';

export const APROBACION_SOLICITUD_LOADING = 'APROBACION_SOLICITUD_LOADING';
export const APROBACION_SOLICITUD_LOADED = 'APROBACION_SOLICITUD_LOADED';
export const APROBACION_SOLICITUD_ERROR = 'APROBACION_SOLICITUD_ERROR';

export const PROYECTO_CREAR_LOADING = 'PROYECTO_CREAR_LOADING';
export const PROYECTO_CREAR_LOADED = 'PROYECTO_CREAR_LOADED';
export const PROYECTO_CREAR_ERROR = 'PROYECTO_CREAR_ERROR';
export const PROYECTO_CREAR_RESET = 'PROYECTO_CREAR_RESET';

export const PROYECTO_EDITAR_LOADING = 'PROYECTO_EDITAR_LOADING';
export const PROYECTO_EDITAR_LOADED = 'PROYECTO_EDITAR_LOADED';
export const PROYECTO_EDITAR_ERROR = 'PROYECTO_EDITAR_ERROR';

export const PROYECTOS_SELECT_LOADING = 'PROYECTOS_SELECT_LOADING';
export const PROYECTOS_SELECT_LOADED = 'PROYECTOS_SELECT_LOADED';
export const PROYECTOS_SELECT_ERROR = 'PROYECTOS_SELECT_ERROR';